<section class="p-6">

  <div>

    <!--
    <div class="px-48">
      <div class="mt-4 p-4 bg-gray-100 rounded" *ngIf="form">
        <pre class="text-xs">{{ form.value | json }}</pre>
      </div>
    </div>
    -->

    <div class="bg-white dark:bg-secondary-800 rounded-xl">
      <div class="flex flex-row justify-between items-center mx-auto w-full max-w-7xl px-0 sm:px-6 lg:px-8 py-8">
        <h1 class="text-lg text-secondary-900 dark:text-white font-semibold font-poppins">Unsaved Query</h1>
        <button type="button" disabled="disabled" class="btn btn-rounded disabled:opacity-75" matTooltip="Available soon" matTooltipPosition="above" matTooltipClass="custom-tooltip">
          My Queries
        </button>
      </div>

      <div class="flex flex-col mx-auto w-full max-w-7xl px-0 sm:px-6 lg:px-8">

        <div class="flex flex-row justify-between mb-2 items-center">
          <p class="text-sm text-secondary font-normal">Select filters and enter values.</p>
          <button type="button" class="btn btn-rounded" (click)="resetFilters()">Reset Filters</button>
        </div>

        <!-- advanced-search.component.html -->
        <form [formGroup]="form" id="advanced-search" class="w-full space-y-3 border border-gray-100 dark:border-secondary rounded-xl p-3">
          <div formArrayName="filters">
            <div *ngFor="let filter of filters.controls; let i = index" [formGroupName]="i" class="lg:flex lg:flex-row lg:justify-center items-start w-full lg:space-x-1 mb-3 last:mb-0"
            >
              <!-- Filter Type Selection -->
              <div class="w-full">
                <app-filter-dropdown
                  [showlabel]="false"
                  [control]="getFilterTypeControl(filter)"
                  [required]="true"
                  [options]="filterTypesSelectable"
                  [disabled]="isDefaultLocation(filter)"
                  [customClass]="isDefaultLocation(filter) ? '!bg-gray-50' : ''"
                  placeholder="Select filter type"
                  (optionSelected)="onFilterTypeSelected(i, $event)"
                  class="relative"
                ></app-filter-dropdown>
              </div>

              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="hidden lg:block text-gray-400 size-10 stroke-2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 9h16.5m-16.5 6.75h16.5"/>
              </svg>

              <!-- Dynamic Input/Select based on filter type -->
              <div class="w-full flex items-center mt-3 lg:mt-0">
                <ng-container *ngIf="filter.get('filterType')?.value as filterId; else selectType">
                  <!-- For select type -->
                  <app-filter-dropdown
                    *ngIf="getFilterType(filterId) === 'select'"
                    [showlabel]="false"
                    [control]="getValueControl(filter)"
                    [required]="true"
                    [options]="getFilterOptions(filterId)"
                    [placeholder]="'Select ' + getFilterName(filterId)"
                    (optionSelected)="onOptionSelected(i, $event)"
                  ></app-filter-dropdown>

                  <!-- For combobox-multiselect type -->
                  <app-filter-combobox-multiselect
                    *ngIf="getFilterType(filterId) === 'combobox-multiselect'"
                    [label]="getFilterName(filterId)"
                    [options]="getFilterOptions(filterId)"
                    [required]="true"
                    [placeholder]="'Select ' + getFilterName(filterId)"
                    [formControl]="getValueControl(filter)"
                    (selectionChange)="onMultiSelectChange(i, $event)"
                    class="w-full"
                  ></app-filter-combobox-multiselect>

                  <!-- For input type -->
                  <app-filter-input
                    *ngIf="getFilterType(filterId) === 'input'"
                    [control]="getValueControl(filter)"
                    [required]="true"
                    [type]="'text'"
                    [placeholder]="'Enter ' + getFilterName(filterId)"
                  ></app-filter-input>

                  <!-- For range type -->
                  <app-filter-range
                    *ngIf="getFilterType(filterId) === 'range'"
                    [control]="getValueControl(filter)"
                    [required]="true"
                    [placeholder]="getFilterName(filterId)"
                    [prefix]="getFilterPrefix(filterId)"
                    [suffix]="getFilterSuffix(filterId)"
                    [max]="getFilterMax(filterId)"
                    class="w-full"
                  ></app-filter-range>

                  <!-- For proximity type -->
                  <app-filter-proximity
                    *ngIf="getFilterType(filterId) === 'proximity'"
                    [control]="getValueControl(filter)"
                    [required]="true"
                    class="w-full"
                  ></app-filter-proximity>

                  <!-- For tags/keywords type -->
                  <app-filter-tags
                    *ngIf="getFilterType(filterId) === 'tags'"
                    [control]="getValueControl(filter)"
                    [required]="true"
                    [placeholder]="'Enter ' + getFilterName(filterId) + ' (press Enter or comma to add)'"
                    class="w-full"
                  ></app-filter-tags>

                  <!-- Location filter -->
                  <div *ngIf="getFilterType(filter.get('filterType')?.value) === 'location'" class="w-full flex flex-row gap-2">
                    <!-- Country typeahead (required) -->
                    <div class="w-1/3">
                      <app-typeahead-location-input
                        label="Country"
                        [required]="true"
                        [control]="getLocationCountryControl(filter)"
                        [options]="countries"
                        [type]="'country'"
                        placeholder="Search country"
                        (optionSelected)="onCountrySelected(i, $event)"
                      ></app-typeahead-location-input>
                    </div>

                    <!-- Region typeahead (optional) -->
                    <div class="w-1/3">
                      <app-typeahead-location-input
                        label="Region"
                        [required]="false"
                        [control]="getLocationRegionControl(filter)"
                        [options]="getAvailableRegions(getLocationCountryControl(filter).value)"
                        [disabled]="getLocationRegionControl(filter).disabled"
                        [type]="'region'"
                        placeholder="Search for a region"
                        (optionSelected)="onRegionSelected(i, $event)"
                        (selectionCleared)="onRegionCleared(i)"
                        (dropdownToggled)="onRegionDropdownClicked(i)"
                      ></app-typeahead-location-input>
                    </div>

                    <!-- City typeahead (optional) -->
                    <div class="w-1/3">
                      <app-typeahead-location-input
                        label="City"
                        [required]="false"
                        [control]="getLocationCityControl(filter)"
                        [options]="getAvailableCities(getLocationRegionControl(filter).value)"
                        [disabled]="getLocationCityControl(filter).disabled"
                        [type]="'city'"
                        placeholder="Search for a city"
                        (optionSelected)="onCitySelected(i, $event)"
                        (selectionCleared)="onCityCleared(i)"
                        (dropdownToggled)="onCityDropdownClicked(i)"
                      ></app-typeahead-location-input>
                    </div>
                  </div>

                </ng-container>

                <ng-template #selectType>
                  <div class="w-full bg-gray-50 dark:bg-secondary rounded-md px-3 py-[0.4rem]">
                    <span class="text-sm text-gray-400">Please select a filter type first</span>
                  </div>
                </ng-template>
              </div>

              <!-- Remove Button -->
              <button type="button" (click)="removeFilter(i)" class="hover:bg-red-100 p-2 rounded-full" [ngClass]="{'invisible': filter.get('isDefault')?.value}">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-5 text-red-500">
                  <path d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                </svg>
              </button>

            </div>
          </div>
        </form>

        <div class="lg:flex lg:justify-between w-full mt-4">

          <button (click)="addFilter()" class="btn btn-rounded flex items-center space-x-1 text-sm">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-4 text-blue-royal">
              <path d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z" />
            </svg>
            <span class="text-blue-royal !font-normal">Add Filter</span>
          </button>

          <div class="flex justify-between space-x-6 mt-6 lg:mt-0">
            <button disabled="disabled" class="btn btn-rounded disabled:opacity-75" matTooltip="Available soon" matTooltipPosition="left" matTooltipClass="custom-tooltip">
              Save Query
            </button>

            <!-- routerLink="/advanced-search/companies" -->
            <a (click)="onSearch()" class="btn btn-blue cursor-pointer lg:w-auto px-6">
              Search
            </a>
          </div>

        </div>

        <div class="w-full mt-8 mb-8 flex justify-between flex-row">

          <div>
            <a routerLink="/reports" class="btn btn-rounded flex items-center space-x-1 text-sm">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-4 text-blue-royal">
                <path fill-rule="evenodd" d="M17 10a.75.75 0 0 1-.75.75H5.612l4.158 3.96a.75.75 0 1 1-1.04 1.08l-5.5-5.25a.75.75 0 0 1 0-1.08l5.5-5.25a.75.75 0 1 1 1.04 1.08L5.612 9.25H16.25A.75.75 0 0 1 17 10Z" clip-rule="evenodd" />
              </svg>
              <span class="text-blue-royal !font-normal">Back</span>
            </a>
          </div>

        </div>
      </div>
    </div>

  </div>

</section>
